<div class="snackbar" *ngIf="visible">{{message}}</div>
